var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2995",
    "data-name": "Group 2995",
    transform: "translate(-712 -167)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 40,
    height: 40,
    transform: "translate(712 167)",
    fill: "#5edc98",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "com",
    transform: "translate(543.91 -1.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9273",
    "data-name": "Path 9273",
    d: "M188.088,207.339a19.265,19.265,0,1,1,15.663-30.484,1.376,1.376,0,0,1-.145,1.775l-.783.785-1.1-1.1-.205.147h0a16.512,16.512,0,1,0,3.084,9.612h2.752a19.286,19.286,0,0,1-19.265,19.265Z",
    transform: "translate(0 0)",
    fill: "#5edc98",
    stroke: "#5edc98",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9274",
    "data-name": "Path 9274",
    d: "M256.368,280.805a1.376,1.376,0,0,1-.973-.4l-8.257-8.257,1.946-1.946,7.284,7.283,15.54-15.54,2.119,1.789L257.341,280.4h0a1.376,1.376,0,0,1-.973.4Z",
    transform: "translate(-71.031 -84.474)",
    fill: "#5edc98",
    stroke: "#5edc98",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTick);
export default __webpack_public_path__ + "static/media/circle_tick.48ffe315b4376e2cd98c680cee3f4597.svg";
export { ForwardRef as ReactComponent };